import type { ReactElement } from 'react';

export function CalendarSkeleton(): ReactElement {
  return (
    <div
      className="grid grid-cols-7 gap-1"
      data-testid="calendar-skeleton"
    >
      {Array.from({ length: 42 }).map((_, i) => (
        <div
          key={i}
          className="flex h-[88px] animate-pulse flex-col gap-1 rounded-lg border p-2"
          style={{
            borderColor: 'var(--border)',
            background: 'var(--bg-surface)',
          }}
        >
          <div className="h-3 w-6 rounded" style={{ background: 'var(--border)' }} />
          <div className="h-2 w-3/4 rounded" style={{ background: 'var(--border)' }} />
          <div className="h-2 w-1/2 rounded" style={{ background: 'var(--border)' }} />
        </div>
      ))}
    </div>
  );
}
